import styled from 'styled-components'

export const Top = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  padding-bottom: ${({ theme }) => theme.sizes.xxl};
`
